import { GymTypes } from 'fitbeat.models';
import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { CardioOrResistance, Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';
import { isHomeBoxingWorkout } from './boxing-zone-helper';

export class BodyGroupManualSelectionFilter implements IExerciseSelectionFilter {
    public description: string = 'Returns only exercises that match users 3 body group setting';
    public name: string = 'ThreeBodyGroupsFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[],
                  workoutStartDate: Date,
                  gymType: GymTypes,
                ): Exercise[] {
        const threeBodyGroupsSetting = userWorkoutSettings.threeBodyGroups;

        // none selected should ignore filter
        if (threeBodyGroupsSetting == null || threeBodyGroupsSetting.length === 0) {
            return inputExercises;
        }
        const smallBodyGroups = Exercise.getSmallBodyGroupsFor3BodyGroups(threeBodyGroupsSetting).sort();

        const shouldAllowAllBodyGroups = userWorkoutSettings.cardioOrResistance === CardioOrResistance.Resistance
                                          && userWorkoutSettings.allowBagContact;

        if (shouldAllowAllBodyGroups || isHomeBoxingWorkout(userWorkoutSettings, gymType)) {
            return inputExercises;
        } else {
            return inputExercises.filter((e) => {
                const matched = e.bodyGroups.filter((bodyGroup) =>
                    smallBodyGroups.indexOf(bodyGroup) !== -1,
                );

                return matched.length > 0;
            });
        }
    }

}
